// extracted by mini-css-extract-plugin
export default {"tooltipList":"Wn1zGgwTdxpVT5ODzx_c"};